<template>
  <a-data-table
    v-model="selected"
    :headers="headers"
    :items="userlist"
    :single-select="singleSelect"
    item-key="email"
    show-select
    class="elevation-1 mt-2 max-height"
    item-class="email-"
    hide-default-footer
    disable-sort
    dense
    disable-pagination
    fixed-header
  >
    <template v-slot:[`item.name`]="{ item }">
      <span
        ><v-avatar
          size="36px"
          class="mt-1 mb-1 mr-1"
          style="display: inline-block"
        >
          <v-img
            v-if="item.profilePhoto"
            contain
            :src="item.profilePhoto"
          ></v-img>
          <v-img v-else contain src="@/assets/images/NoPhotoIcon.png"></v-img>
        </v-avatar>
        <v-tooltip bottom :disabled="!isEllipsis(item.name)">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" style="display: inline-block">
              <span>{{ ellipsis(item.name) }}</span>
            </div>
          </template>
          <span v-text="item.name"></span>
        </v-tooltip>
      </span>
    </template>
    <template v-slot:[`item.email`]="{ item }">
      <v-list-item dense style="min-height: 40px; height: 40px" class="pt-2">
        <v-list-item-content>
          <v-list-item-title class="text-body-2 font-weight-regular">
            <v-tooltip bottom :disabled="!isEllipsis(item.email, 50)">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" style="display: inline-block">
                  <span>{{ ellipsis(item.email, 50) }}</span>
                </div>
              </template>
              <span v-text="item.email"></span>
            </v-tooltip>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-card
        flat
        v-if="item.contactEmailIds && item.contactEmailIds.length > 0"
        style="background-color: inherit"
        class="pb-2"
      >
        <v-list-item
          dense
          v-for="email in item.contactEmailIds"
          :key="`email-contact-emails-list-${email}`"
          style="min-height: 32px; height: 32px"
        >
          <v-list-item-content>
            <v-list-item-title class="text-body-2 font-weight-regular">
              <v-tooltip bottom :disabled="!isEllipsis(email, 50)">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="display: inline-block">
                    <span>{{ ellipsis(email, 50) }}</span>
                  </div>
                </template>
                <span v-text="email"></span>
              </v-tooltip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </template>
  </a-data-table>
</template>

<script>
export default {
  name: "EmailUsersList",
  props: {
    userlist: Array,
    value: {
      type: Array,
      required: () => [],
    },
  },
  data() {
    return {
      singleSelect: false,
      stringLength: 25,
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
    headers() {
      return [
        {
          text: this.$t("documents.name"),
          align: "start",
          sortable: false,
          value: "name",
          class: "header",
          width: "36%",
        },
        {
          text: this.$t("lblEmail"),
          value: "email",
          class: "header email-td",
        },
      ];
    },
  },
  methods: {
    isEllipsis(string, length) {
      const strlen = length != undefined ? length : this.stringLength;
      return String(string).length > strlen;
    },
    ellipsis(string, length) {
      const strlen = length != undefined ? length : this.stringLength;
      return this.isEllipsis(string, length)
        ? string.substring(0, strlen) + "..."
        : string;
    },
  },
};
</script>

<style scoped>
.max-height {
  max-height: 32vh;
  overflow: auto;
}

::v-deep .v-input--selection-controls__ripple {
  border-radius: unset !important;
  height: unset !important;
  width: unset !important;
}

.v-data-table /deep/ .sticky-header {
  position: sticky;
}

.v-data-table /deep/ .v-data-table__wrapper {
  overflow: unset;
}
.v-data-table
  /deep/
  .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__row {
  background-color: #edf8ff;
}
.v-data-table
  /deep/
  .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: none;
  background-color: #fff;
}
.v-data-table /deep/ .v-data-table-header tr:first-child {
  padding: 0px;
}

.v-data-table /deep/ tbody tr td {
  vertical-align: top;
}
.v-data-table /deep/ tbody tr td .v-data-table__checkbox {
  padding-top: 10px;
}
</style>